<!-- No firing log found state -->
<div *ngIf="!gotFilename" class="no-log-container">
  <div class="no-log-card">
    <div class="no-log-icon">
      <ion-icon name="document-outline"></ion-icon>
    </div>
    <h3 class="no-log-title">{{ 'FIRING_LOG.NO_FIRING_LOG_AVAILABLE' | translate }}</h3>
    <p class="no-log-description">
      {{ 'FIRING_LOG.NO_FIRING_LOGS_YET' | translate }}
    </p>
    <div class="no-log-info">
      <ion-icon name="information-circle-outline"></ion-icon>
      <span>{{ 'FIRING_LOG.UPLOAD_INSTRUCTIONS' | translate }}</span>
    </div>
  </div>
</div>

<!-- Firing log found state -->
<div *ngIf="gotFilename" class="log-container">
  <div class="log-card">
    <div class="log-header">
      <div class="log-icon">
        <ion-icon name="document-text-outline"></ion-icon>
      </div>
      <div class="log-info">
        <h3 class="log-title">{{ 'FIRING_LOG.LATEST_FIRING_LOG' | translate }}</h3>
        <p class="log-filename">{{logName}}</p>
      </div>
    </div>
    <div class="log-actions">
      <ion-button 
        fill="solid" 
        color="primary" 
        size="medium" 
        (click)="download()"
        class="download-button">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        {{ 'FIRING_LOG.DOWNLOAD_LOG' | translate }}
      </ion-button>
    </div>
  </div>
</div>